// /src/renderer/shared/components/Table/TableHeader.tsx
import React from 'react';
import { ReactComponent as SortIcon } from 'img/sort-light.svg';
import { ReactComponent as SortUpIcon } from 'img/sort-up-duotone-solid.svg';
// import './TableHeader.scss';
import styles from './TableHeader.module.scss';
import { useBrowserPage } from '@features/browser/useBrowserPage';
import { StudySortKeys } from 'config/studyConfig';

export interface TableHeaderProps {
  id: string;
  label: string;
  allowsSorting?: boolean;
  className?: string;

  draggable?: boolean;
  isDragging?: boolean;
  isDragOver?: boolean;
  onDragStart?: (e: React.DragEvent, id: string) => void;
  onDragOver?: (e: React.DragEvent, id: string) => void;
  onDrop?: (e: React.DragEvent, id: string) => void;
  onDragEnd?: (e: React.DragEvent, id: string) => void;
}

const SORT_TYPE = {
  DEFAULT: 'default' as const,
  ASC: 'ASC' as const,
  DESC: 'DESC' as const,
};

export default function TableHeader({
  id,
  label,
  allowsSorting = false,
  className = '',
  draggable = false,
  isDragging = false,
  isDragOver = false,
  onDragStart,
  onDragOver,
  onDrop,
  onDragEnd,
}: TableHeaderProps) {
  const { StudyViewState, updateSortOptions } = useBrowserPage();

  const sortType: 'ASC' | 'DESC' | 'default' =
    StudyViewState.sortOption?.sortBy === id
      ? (StudyViewState.sortOption?.sortDirection ?? SORT_TYPE.DEFAULT)
      : SORT_TYPE.DEFAULT;

  const determineNewOrder = (current: 'ASC' | 'DESC' | 'default') => {
    switch (current) {
      case SORT_TYPE.DESC:
        return SORT_TYPE.ASC;
      case SORT_TYPE.ASC:
        return SORT_TYPE.DEFAULT;
      default:
        return SORT_TYPE.DESC;
    }
  };

  const handleSort = () => {
    if (!allowsSorting) return;

    const next = determineNewOrder(sortType);

    if (next === 'default') {
      updateSortOptions({});
    } else {
      updateSortOptions({
        sortBy: id as StudySortKeys,
        sortDirection: next,
      });
    }
  };

  const renderSortButton = () => {
    if (!allowsSorting) return null;
    return (
      <button
        className={styles.icon}
        type="button"
        onClick={handleSort}
        aria-label={`Sort ${label}`}
      >
        {sortType === SORT_TYPE.DEFAULT ? (
          <SortIcon />
        ) : (
          <SortUpIcon
            className={`${sortType === SORT_TYPE.DESC ? styles.rotated : ''}`}
          />
        )}
      </button>
    );
  };

  return (
    <div
      id={id}
      // className={`table-header-container ${isDragging ? ' dragging' : ''} ${isDragOver ? ' drag-over' : ''} ${id==='studyDescription'?' fixed':''} ${className}`}
      className={`${styles.container} ${isDragging ? styles.dragging : ''} ${isDragOver ? styles.dragOver : ''} ${id==='studyDescription'? styles.fixed:''} ${className}`}
      onDragOver={onDragOver ? (e) => onDragOver(e, id) : undefined}
      onDrop={onDrop ? (e) => onDrop(e, id) : undefined}
    >
      {/* <div className="table-header"> */}
        <div
          // className={`table-header`}
          className={styles.header}
          // className={`table-header${id==='studyDescription'?' fixed':''}`}
          draggable={draggable}
          onDragStart={onDragStart ? (e) => onDragStart(e, id) : undefined}
          onDragEnd={onDragEnd ? (e) => onDragEnd(e, id) : undefined}
          title={draggable ? 'Drag to reorder' : undefined}
        >
          <span className={styles.label}>{label}</span>
          {renderSortButton()}
        </div>
      {/* </div> */}
    </div>
  );
}
